<template>
  <div class="box" v-if="layerGroup" style="background-color:  #eeeeee; border: 1px solid #cccccc; width: 280px;">
    <div
        @click="expanded = !expanded"
        class="icon"
        :class="{ 'icon-open': expanded, 'icon-closed': !expanded}"
        :title="expanded ? 'Collapse' : 'Show all'"
    >
      <img src="./arrow.png" height="20" width="20">
    </div>
    <div class="title" style="font-size: 16pt;" @click="expanded = true">
      {{ layerGroup.name }}
    </div>
    <div class="columns" v-if="expanded">
      <div class="column" v-if="layerGroup.subLayers.length > 1">
        <a class="panel-block"
           style="font-size: 10pt; text-wrap: avoid;"
           v-for="(l, key) in layerGroup.subLayers" :key="key"
           :class="{'active': l.id === layer.id}"
           @click="select(l)"
        >
          <legend-item :layer="l"></legend-item>
        </a>
      </div>
      <div class="column" v-if="showUncertaintyLayer">
        <div v-if="currentLanguage==0" style="font-size: 10pt; opacity: 0.9; margin-bottom: 10px;">
          Breite des 90%-Vorhersageintervalls
        </div>
        <div v-else-if="currentLanguage==1" style="font-size: 10pt; opacity: 0.9; margin-bottom: 10px;">
          Largeur de l'intervalle de prédiction à 90 %.
        </div>
        <div v-else-if="currentLanguage==2" style="font-size: 10pt; opacity: 0.9; margin-bottom: 10px;">
          Width of the 90% prediction interval
        </div>
        <div>
          <div>
            {{ currentUncertaintyLegend.legend[0].label.split(' - ')[0] }}
          </div>
          <img :src="'data:image/png;base64,' + currentUncertaintyLegend.legend[0].imageData">
          <div>
            {{ currentUncertaintyLegend.legend[0].label.split(' - ')[1] }}
          </div>
        </div>
      </div>
      <div class="column" v-else>
        <div v-for="(item, key) in currentLegend.legend" :key="key"
             style="font-size: 10pt; display: flex; margin: 2px;">
          <img :src="'data:image/png;base64,' + item.imageData" :height="item.height" :width="item.width">
          <span style=" padding-left: 3px;">
          {{ item.label }}
            </span>
        </div>
      </div>
    </div>

    <div style="opacity: 0.7; font-size: 10pt;" v-if="expanded && currentLanguage==0">Transparenz</div>
    <div style="opacity: 0.7; font-size: 10pt;" v-else-if="expanded && currentLanguage==1">Transparency</div>
    <div style="opacity: 0.7; font-size: 10pt;" v-else-if="expanded && currentLanguage==2">Transparence</div>

    <div class="slider-container" v-if="expanded">
      <input class="slider" type="range" min="0" max="100" v-model="opacity">
    </div>

    <div style="font-size: 10pt; margin-top: 10px;" v-if="expanded">
      <label class="checkbox">
        <input type="checkbox" v-model="showUncertaintyLayer">
        <span v-if="currentLanguage==0" style="padding-left:6px">Layer Unsicherheit</span>
        <span v-else-if="currentLanguage==1" style="padding-left:6px">Couche d'incertitude</span>
        <span v-else-if="currentLanguage==2" style="padding-left:6px">Uncertainty Layer</span>
      </label>
    </div>
  </div>
</template>

<script>
import LegendItem from "@/components/LegendItem"

export default {
  name: "Legend",
  components: {LegendItem},
  data() {
    return {
      legend: null,
      opacity: 100,
      expanded: true,
      legendKey: 0
    }
  },
  mounted () {
    this.emitter.on('reloadLegend', (args) => {

      // remove legend..
      this.emitter.emit('removeLayer','removeLayer')
      this.$store.commit('setLayerGroup', null)

      // ..and reload it
      this.legendKey = this.legendKey + 1

    })
  },

  computed: {
    layerGroup() {
      return this.$store.state.layerGroup
    },
    layer() {
      return this.$store.state.layer
    },
    showUncertaintyLayer: {
      get() {
        return this.$store.state.showUncertaintyLayer
      },
      set(value) {
        this.$store.commit('showUncertaintyLayer', value)
      }
    },
    currentLegend() {
      return this.$store.getters.currentLegend
    },
    currentUncertaintyLegend() {
      return this.$store.getters.currentUncertaintyLegend
    },
    currentLanguage() {
      return this.$store.getters.currentLanguage
    }
  },
  methods: {
    select(l) {
      this.$store.commit('setLayer', l)
    }
  },
  watch: {
    opacity() {
      this.$store.commit('setOpacity', this.opacity)
    }
  }
}
</script>

<style scoped>
.active {
  background-color: aquamarine;
}

.slider-container {
  width: 100%;
  opacity: 0.5;
}

.slider-container:hover {
  opacity: 1;
}

.slider {
  width: 100%;
  background: #d3d3d3;
  outline: none;
}

.icon-open {
  transform: rotate(90deg);
}

.icon-closed {
  transform: rotate(270deg);
}

.icon {
  cursor: pointer;
  top: 0;
  right: 0;
  float: right;
  font-size: 12pt;
  width: 20px;
  height: 20px;
  opacity: 0.7;
}

.icon:hover {
  opacity: 1;
}
</style>
